import Tabs, { TabsProps, Tab } from './Tabs'
import TabsCarousel, { Slide as TabsCarouselSlide } from './TabsCarousel'
import { TabsCarouselPanel } from './TabsCarouselPanel'

export default Tabs

export { type TabsProps, Tabs, Tab, TabsCarousel, TabsCarouselSlide, TabsCarouselPanel }
